function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.83619 8.75804C2.39622 6.41506 2.94325 4.06807 3.52129 1.73008C3.90431 0.18409 4.53135 -0.240907 6.05244 0.121091C9.18962 0.869087 12.3188 1.66408 15.443 2.47008C16.7701 2.81408 17.2191 3.56407 16.9031 4.90806C15.76 9.76404 14.6009 14.614 13.4249 19.461C13.1138 20.741 12.3858 21.214 11.1277 20.912C7.87054 20.127 4.62135 19.31 1.37616 18.471C0.171092 18.159 -0.20893 17.412 0.105088 16.037C0.66212 13.605 1.25816 11.184 1.83619 8.75804Z",
  fill: "#F5F500"
});

var SvgYellow = function SvgYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellow.6bb0ed05.svg";
export { ForwardRef as ReactComponent };